// extracted by mini-css-extract-plugin
export default {"time":"style_time__wnNIH","danger":"style_danger__y64IW"};